"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _reactHelmet = _interopRequireDefault(require("react-helmet"));

var _requestSchedule = require("../../redux/modules/_BETA/requestSchedule");

var _ProjectSettings = require("../../components/ProjectSettings/");

var _useActions = require("../../context/settings/config/useActions");

var _useActions2 = require("../../context/settings/rules/useActions");

const ProjectSettingsScene = ({
  sites,
  siteList,
  projectList,
  insightType,
  setRequestInsightsFlag
}) => {
  const {
    updateInsightType
  } = (0, _useActions.useActions)();
  const {
    getRules
  } = (0, _useActions2.useActions)();
  React.useEffect(() => {
    void getRules();
  }, []);
  React.useEffect(() => {
    updateInsightType(insightType);
  }, [insightType]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_reactHelmet.default, {
    title: "Project Settings"
  }), /*#__PURE__*/React.createElement(_ProjectSettings.ProjectSettings, {
    onSave: setRequestInsightsFlag,
    projectList: projectList,
    sites: sites,
    siteList: siteList
  }));
};

function mapDispatchToProps(dispatch) {
  return {
    setRequestInsightsFlag: () => {
      dispatch((0, _requestSchedule.setShouldRequestInsights)(true));
      dispatch((0, _requestSchedule.setShouldRequestMonitoring)(true));
    }
  };
}

var _default = (0, _reactRedux.connect)(null, mapDispatchToProps)(ProjectSettingsScene);

exports.default = _default;
module.exports = exports.default;